import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface Skill {
  id: string;
  name: string;
  icon: string | null;
  type_skill?: string | null;
  created_at: string;
  updated_at: string;
}

export const useSkills = () => {
  return useQuery({
    queryKey: ["skills"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("skills")
        .select("*")
        .order("name");
      
      if (error) {
        throw new Error(`Failed to fetch skills: ${error.message}`);
      }
      
      return data as Skill[];
    },
  });
};